import React from "react"
import { Link } from "react-router-dom"
import { ArrowRight } from "lucide-react"

export default function NotFound() {
  return (
    <main className="pt-24 min-h-screen bg-stone-950 flex items-center justify-center">
      <div className="text-center px-6">
        <div className="font-['Cormorant_Garamond'] text-[120px] lg:text-[200px] font-light text-stone-900 leading-none select-none mb-0">
          404
        </div>
        <h1 className="font-['Cormorant_Garamond'] text-3xl lg:text-5xl font-light text-stone-200 mb-4 -mt-4">
          Page not found
        </h1>
        <p className="font-['Inter'] text-sm text-stone-500 mb-10 max-w-xs mx-auto">
          The page you're looking for has moved, been removed, or never existed.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-3 bg-amber-400 text-stone-950 px-8 py-4 font-['Space_Grotesk'] text-xs tracking-[0.2em] font-medium hover:bg-amber-300 transition-colors group"
        >
          RETURN HOME
          <ArrowRight size={13} className="group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </main>
  )
}
